// 새로운 객체를 생성하여 빈 문자열 값을 필터링하는 유틸함수
export function filterEmptyValues<T extends Record<string, any>>(
  obj: T
): Partial<T> {
  const result: Partial<T> = {}; // 빈 객체를 생성 (Partial<T>는 T의 부분 집합을 의미)

  for (const key of Object.keys(obj) as Array<keyof T>) {
    // obj의 키를 keyof T로 강제 타입 지정
    if (obj[key] !== '') {
      result[key] = obj[key];
    }
  }

  return result;
}

// 최신순
export function sortByNewest(arr: HealthRecord[]) {
  return [...arr].sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );
}

// 오래된순
export function sortByOldest(arr: HealthRecord[]) {
  return [...arr].sort(
    (a, b) =>
      new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );
}

// 오름차순
export function sortAscending(arr: HealthRecord[]) {
  return [...arr].slice().sort((a, b) => {
    if (a.title > b.title) return 1;
    if (a.title < b.title) return -1;
    return 0;
  });
}

// 내림차순
export function sortDescending(arr: HealthRecord[]) {
  return [...arr].slice().sort((a, b) => {
    if (a.title > b.title) return -1;
    if (a.title < b.title) return 1;
    return 0;
  });
}

// 주어진 이름의 쿠키를 반환하는데,
// 조건에 맞는 쿠키가 없다면 undefined를 반환합니다.
export function getCookie(name: string) {
  let matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
        '=([^;]*)'
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setCookie(name: string, value: string, options: any = {}) {
  options = {
    path: '/',
    // 필요한 경우, 옵션 기본값을 설정할 수도 있습니다.
    ...options,
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie =
    encodeURIComponent(name) + '=' + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += '; ' + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += '=' + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

export function deleteCookie(name: string) {
  setCookie(name, '', {
    'max-age': -1,
  });
}

export function formatDateString(dateString: string, showTime = true) {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return '';
  }

  // 연도, 월, 일 추출
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 월은 0부터 시작하므로 +1
  const day = date.getDate().toString().padStart(2, '0');

  // 시간과 분 추출
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  const result = showTime
    ? `${year}.${month}.${day} ${hours}:${minutes}`
    : `${year}.${month}.${day}`;

  return result;
}

export function formatDate(date: Date, showTime = true, separator = '.') {
  // 연도, 월, 일 추출
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 월은 0부터 시작하므로 +1
  const day = date.getDate().toString().padStart(2, '0');

  // 시간과 분 추출
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  // 포맷에 맞춰 조합
  return showTime
    ? `${year}${separator}${month}${separator}${day} ${hours}:${minutes}`
    : `${year}${separator}${month}${separator}${day}`;
}

// @TODO: 컴포넌트 코드 내에서 alert() 직접 사용을 린트로 제한하기
export function alertMessage(message: string) {
  window.electron ? window.electron.showDialog(message) : window.alert(message);
}

// pc 환경인지 아닌지 userAgent로 판별하는 유틸함수
export function isPC() {
  const userAgent = navigator.userAgent;
  const mobileOrTabletRegex = /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i;

  // 모바일 또는 태블릿이 아니라면 PC로 간주
  return !mobileOrTabletRegex.test(userAgent);
}

export function formatPriceComma(num: number) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function getOrigin() {
  const isElectron = !!window.electron;
  return isElectron ? process.env.VITE_APP_URL : window.location.origin;
}
